import React from "react";
import {
  FaServer,
  FaProjectDiagram,
  FaUsers,
  FaFileContract,
  FaWallet,
  FaMobileAlt,
  FaVrCardboard,
  FaImage,
  FaExchangeAlt,
} from "react-icons/fa";

function Consultation() {
  const platforms = [
    {
      icon: <FaServer size={32} />,
      title: "Blockchain Consultation & Integration",
      desc: "From strategy to implementation, our blockchain experts provide comprehensive guidance throughout your blockchain application journey, ensuring successful and seamless integration.",
    },
    {
      icon: <FaProjectDiagram size={32} />,
      title: "Layer 2 Development",
      desc: "We design innovative Layer 2 solutions that enhance the scalability of base-layer blockchains. Our team specializes in developing Layer 2 protocols, including rollups and state channels.",
    },
    {
      icon: <FaUsers size={32} />,
      title: "Blockchain Protocol Development",
      desc: "Our capabilities span the complete protocol development lifecycle, from consensus mechanisms to governance structures. We deliver scalable, customized blockchain protocols suited to your unique requirements.",
    },
    {
      icon: <FaExchangeAlt size={32} />,
      title: "Centralized/Decentralized Exchange Development",
      desc: "Xeer creates high-performance, secure trading platforms tailored for seamless cryptocurrency transactions, catering to both centralized and decentralized exchanges.",
    },
    {
      icon: <FaImage size={32} />,
      title: "NFT Marketplace Development",
      desc: "Our customizable NFT marketplaces feature multi-chain support, smart contract integration, and secure payment gateways, providing safe and efficient token trading experiences.",
    },
    {
      icon: <FaFileContract size={32} />,
      title: "Smart Contract Development & Audit",
      desc: "We design, develop, and audit smart contracts across major blockchain platforms, rigorously testing to ensure compliance and reliability.",
    },
    {
      icon: <FaWallet size={32} />,
      title: "Crypto Wallet Development",
      desc: "Xeer’s crypto wallet development services prioritize security with advanced encryption and multi-signature authentication for safe digital asset management.",
    },
    {
      icon: <FaMobileAlt size={32} />,
      title: "Decentralized App (dApp) Development",
      desc: "Our dApp development services cover the full lifecycle, ensuring high-quality, value-driven solutions that enhance digital presence.",
    },
    {
      icon: <FaVrCardboard size={32} />,
      title: "Metaverse Development",
      desc: "We craft immersive metaverse solutions, from avatars to AR/VR applications, aligning with clients' business objectives to bridge digital and physical experiences.",
    },
  ];
  return (
    <>
      <div style={{ padding: "80px 0", background: "#fff" }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2
              className="fw-bold"
              style={{ color: "#0a1f44", fontSize: "clamp(24px, 3vw, 38px)" }}
            >
              Our Blockchain Development Services
            </h2>
            <p className="text-muted mx-auto" style={{ maxWidth: "700px" }}>
              Xeer Technology offers a full range of blockchain development
              services to help businesses leverage the power of blockchain in
              the evolving web3 space.
            </p>
          </div>
          <div className="row g-4">
            {platforms.map((item, idx) => (
              <div className="col-lg-4 col-md-6" key={idx}>
                <div className="ce-platform-card">
                  <div className="ce-platform-icon d-flex align-items-center justify-content-center">
                    {item.icon}
                  </div>
                  <h5
                    className="fw-bold mb-2"
                    style={{ color: "#0a1f44", fontSize: "17px" }}
                  >
                    {item.title}
                  </h5>
                  <p
                    className="mb-0 text-muted"
                    style={{ fontSize: "14px", lineHeight: "1.6" }}
                  >
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Consultation;
